import React from 'react'
import PropTypes from 'prop-types'
import InlineSVG from 'svg-inline-react'
import classNames from 'classnames'

import styles from './Select.module.scss'

import iconDropDown from '!raw-loader!shared/assets/icons/dropdown.svg'

const renderData = data => data.map((item, i) => {
  if (Array.isArray(item?.items) && item.items.length) {
    return (
      <optgroup label={item.name} key={i}>
        {renderData(item.items)}
      </optgroup>
    )
  }
  return (
    <option key={i} value={item.code}>{item.name}</option>
  )
})

const Select = ({
  title,
  data,
  value,
  onChange,
  disabled,
  className
}) => (
  <div className={styles.wrapper}>

    <div className={styles.title}>
      {title}
    </div>

    <div className={styles.selectWrapper}>
      <select
        className={classNames(
          styles.select,
          Boolean(className) && className
        )}
        onChange={onChange}
        value={value}
        disabled={disabled}
      >
        {renderData(data)}
      </select>

      <InlineSVG
        className={styles.icon}
        src={iconDropDown}
      />
    </div>
  </div>
)

Select.propTypes = {
  title: PropTypes.string,
  disabled: PropTypes.bool,
  data: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  className: PropTypes.string
}

export default Select
